import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { formatDate } from "../../../utils/commonFunctions";
import Comments from "../Comments";
type AppProps = {
  modal: boolean;
  toggleModal: () => void;
  data: any;
  commentList: any;
  handlePostComment: (data?: any) => void;
  commentLabel?: string;
};

const CommentModal = ({
  modal,
  toggleModal,
  data,
  commentList,
  handlePostComment,
  commentLabel,
}: AppProps) => {
  const [commentText, setCommentText] = useState<string>("");
  const handleSubmitComment = (e: any) => {
    e.preventDefault();

    handlePostComment(commentText);
    setCommentText("");
  };

  const handleCommentTextChange = (e: any) => {
    setCommentText(e.target.value);
  };

  const renderAllComments = () => {
    const finalComments = commentList?.map((el: any, index: number) => {
      return (
        <Comments
          key={index}
          commenterName={
            el?.commented_by?.first_name + " " + el?.commented_by?.last_name
          }
          commentTime={el?.comment_at}
          commentText={el?.comment}
          image={el?.commented_by?.profile_pic}
        />
      );
    });

    return finalComments;
  };
  return (
    <Modal isOpen={modal} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>All Comments</ModalHeader>
      <ModalBody>
        {data ? data : ""}
        <form>
          <div className="form-group mt-3">
            <label htmlFor="commentBox" className={commentText ? "active" : ""}>
              {commentLabel ? commentLabel : ""}
            </label>
            <textarea
              className={`form-control`}
              name="text"
              value={commentText}
              autoFocus
              onChange={(e) => handleCommentTextChange(e)}
              onKeyPress={(e: any) =>
                e.key === "Enter"
                  ? commentText?.trim() && handleSubmitComment(e)
                  : null
              }
              style={{ height: "100px" }}
            />
          </div>
        </form>
        <div className="text-right">
          <span className="pointer" onClick={toggleModal}>
            Cancel
          </span>
          <Button
            color="primary ml-3"
            onClick={(e: any) => {
              handleSubmitComment(e);
            }}
            disabled={!commentText?.trim()?.length}
          >
            Post
          </Button>
        </div>
      </ModalBody>
      <ModalFooter>
        {!!commentList && commentList?.length > 0 ? (
          <div className="w-100 comment-area">{renderAllComments()}</div>
        ) : (
          <div className="w-100 text-center due-date-text">
            No Older Comments!
          </div>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default CommentModal;
